import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import classnames from 'classnames';
import _last from 'lodash/last';
import * as Queries from '../../graphQL/queries/shipmentQueries';
import ErrorNotification from '../../components/common/ErrorNotification';
import LoadingIndicator from '../../components/LoadingIndicator';
import { AppContext } from '../../AppProvider';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import BOLStyles from './__styles__/BOL.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';

import {
  LOCATION_TYPE,
  BOL_DISCLAIMER,
  BOL_SHIPPER_TEXT,
  BOL_CARRIER_TEXT
} from '../../constants/constants';

import BOLCharges from './Charges';
import BOLLocation from './Location';
import BOLHeader from './Header';
import BOLUnit from './UnitInfo';
import BOLServices from './Services';
import BOLReferences from './References';

import PoweredByImg from '../../images/powered_by_propel.png';

class BOL extends Component {
  state = { shipment: {}, loading: true };

  async componentDidMount() {
    const {
      match: {
        params: { id }
      },
      client,
      t
    } = this.props;

    if (!id) {
      this.setState({ loading: false, error: t('No shipment information!') });
      return;
    }
    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(false);
    setSidebarVisible(false);

    // Determine which query we are calling based on the type of 'id'
    if (isNaN(id)) {
      const {
        data: {
          unauthenticated: { shipment }
        }
      } = await client.query({
        query: Queries.unauthenticatedShipmentById,
        variables: { id }
      });

      this.setState({
        shipment,
        loading: false
      });
    } else {
      const {
        data: {
          shipment: { shipmentForBol: shipment }
        }
      } = await client.query({
        query: Queries.shipmentByIdForBol,
        variables: { id }
      });

      this.setState({
        shipment,
        loading: false
      });
    }

    // need a slight delay here before we print to make sure
    // everything gets fully loaded
    setTimeout(() => {
      window.print();
      window.close();
    }, 500);
  }

  // componentDidUpdate() {
  //   // wait for it... The Beacon icon will pop up eventually.  We want to hide it for the print.
  //   if (document.getElementById('HSBeaconFabButton')) {
  //     document.getElementById('HSBeaconFabButton').hidden = true;
  //   }
  // }

  componentWillUnmount() {
    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(true);
    setSidebarVisible(true);
    document.getElementById('HSBeaconFabButton').hidden = false;
  }

  render() {
    const { shipment, loading, error } = this.state;
    const { classes, t } = this.props;

    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return <ErrorNotification message={error} />;
    }

    const pickup = shipment.stops[0];
    const delivery = _last(shipment.stops);
    const handlingUnits = shipment.handlingUnits;

    return (
      <div className={classes.bolText1}>
        <BOLHeader shipment={shipment} />
        <p />
        <Grid container spacing={16}>
          <BOLLocation location={pickup} type={LOCATION_TYPE.PICKUP} />
          <BOLLocation location={delivery} type={LOCATION_TYPE.DELIVERY} />
        </Grid>
        <p />
        <BOLCharges shipment={shipment} />
        <p />
        <Grid container spacing={16}>
          <BOLServices shipment={shipment} />
          <BOLReferences shipment={shipment} />
        </Grid>
        <p />
        {handlingUnits.map((unit, index) => {
          return <BOLUnit key={index} unit={unit} index={index} />;
        })}
        <p />

        <div className={classes.positionBottom}>
          <Grid container spacing={16} className={classes.unitFont}>
            <Grid item xs={4}>
              {t('Shipper Signature')}:
            </Grid>
            <Grid item xs={2}>
              <span className={classes.textMargin}>{t('Date')}:</span>
            </Grid>
            <Grid item xs={4}>
              {t('Carrier Signature')}:
            </Grid>
            <Grid item xs={2}>
              <span className={classes.textMargin}>{t('Date')}:</span>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.unitFont}>
            <Grid item xs={6}>
              <hr className={classes.signature} />
            </Grid>
            <Grid item xs={6}>
              <hr className={classes.signature} />
            </Grid>
          </Grid>

          <Grid container spacing={16}>
            <Grid item xs={6}>
              <p className={classnames(classes.noMargin, classes.tinyFont)}>
                {t(BOL_SHIPPER_TEXT)}
              </p>
            </Grid>
            {/* <Grid item xs={1} /> */}
            <Grid item xs={6}>
              <p className={classnames(classes.noMargin, classes.tinyFont)}>
                {t(BOL_CARRIER_TEXT)}
              </p>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.poweredByMargin}>
            <Grid item xs={3} className={classes.poweredByBkg}>
              <img
                src={PoweredByImg}
                alt={t('Powered By Propel')}
                className={classes.poweredByLogo}
              />
            </Grid>
            <Grid
              item
              xs={9}
              className={classnames(classes.tinyFont, classes.poweredByBkg)}
            >
              {t(BOL_DISCLAIMER)}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

BOL.contextType = AppContext;
const translatedBOL = withNamespaces()(BOL);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(withApollo(translatedBOL));
